module.exports = __webpack_public_path__ + "img/PDF.53d8dc74.png";